import { FC } from "react"
import { Box, Chip, Typography } from "@mui/material"
import { Userbot } from "../../interfaces"
import { shortId } from "./identityFormat"

export interface LeaseChipsProps {
  leases?: Userbot.LeaseInfo[] | null
}

export const LeaseChips: FC<LeaseChipsProps> = ({ leases }) => {
  if (!leases || leases.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    )
  }

  return (
    <Box display="flex" flexWrap="wrap" gap={0.5}>
      {leases.map((lease, idx) => (
        <Chip
          key={`${lease.clientId}-${lease.purpose}-${lease.holder}-${idx}`}
          size="small"
          label={`${lease.purpose}: ${shortId(lease.holder)}`}
          sx={{ fontFamily: "monospace" }}
        />
      ))}
    </Box>
  )
}
